import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { useTranslation } from 'react-i18next';
import type { RecordPaymentResult } from '@freelancer-os/shared-types';
import type { RecordPaymentInput } from '@freelancer-os/validation';
import { fetchApi } from '../lib/api';

function invalidateAll(qc: ReturnType<typeof useQueryClient>) {
  qc.invalidateQueries({ queryKey: ['invoices'] });
  qc.invalidateQueries({ queryKey: ['bookkeeping'] });
}

export function useRecordPayment() {
  const qc = useQueryClient();
  const { t } = useTranslation('payments');
  return useMutation<RecordPaymentResult, Error, RecordPaymentInput>({
    mutationFn: (input) =>
      fetchApi('/payments', {
        method: 'POST',
        body: JSON.stringify(input),
      }),
    onSuccess: () => {
      invalidateAll(qc);
    },
    onError: (err) => {
      toast.error(err.message || t('toast.error'));
    },
  });
}

export function useDeletePayment() {
  const qc = useQueryClient();
  const { t } = useTranslation('payments');
  return useMutation<{ deleted: boolean; invoiceStatus: string | null }, Error, string>({
    mutationFn: (id) => fetchApi(`/payments/${id}`, { method: 'DELETE' }),
    onSuccess: () => {
      invalidateAll(qc);
      toast.success(t('toast.deleted'));
    },
    onError: (err) => {
      toast.error(err.message || t('toast.error'));
    },
  });
}
